import { type ReactNode } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { T } from "@repo/transifex";
import { cn } from "~/lib/utils";

type ReportRowProps = {
  label: string;
  value: string | number | ReactNode;
  className?: string;
} & VariantProps<typeof rowStyles>;

export const ReportRow = ({
  label,
  value,
  variant = "default",
  className
}: ReportRowProps) => (
  <div className={cn(rowStyles({ variant }), className)}>
    <p className={labelStyles({ variant })}>
      {variant === "indented" ? <span className="mr-1">&bull;</span> : null}
      <T _str={label} />
    </p>
    <p className={valueStyles({ variant })}>
      {typeof value === "string" ? <T _str={value} /> : value}
    </p>
  </div>
);

const rowStyles = cva(
  "flex items-center justify-between border-b border-divider-main px-4 py-2.5 last:border-0",
  {
    variants: {
      variant: {
        default: "",
        bold: "bg-gray-100",
        indented: "",
        subheader: "bg-gray-100"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);

const labelStyles = cva("text-sm text-text-primary", {
  variants: {
    variant: {
      default: "",
      bold: "font-semibold",
      indented: "pl-2",
      subheader: "font-semibold"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});

const valueStyles = cva("text-sm text-text-primary", {
  variants: {
    variant: {
      default: "",
      bold: "font-semibold",
      indented: "",
      subheader: "font-semibold"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
